import { render, staticRenderFns } from "./FeedbackDetail.vue?vue&type=template&id=4c2ae534&scoped=true"
import script from "./FeedbackDetail.vue?vue&type=script&lang=js"
export * from "./FeedbackDetail.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDetail.vue?vue&type=style&index=0&id=4c2ae534&prod&scoped=true&lang=less"
import style1 from "./FeedbackDetail.vue?vue&type=style&index=1&id=4c2ae534&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2ae534",
  null
  
)

export default component.exports